"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const modal_1 = __importDefault(require("@clayui/modal"));
const clsx_1 = __importDefault(require("clsx"));
const button_1 = __importStar(require("@ocp/button"));
const icon_1 = __importStar(require("@ocp/icon"));
const types_1 = require("./types");
const ModalHeader = ({ title, titleSize, status, icon = icon_1.IconSymbol.InfoCircle, borderless, onClose, }) => {
    const isTitleSizeSmall = titleSize === types_1.ModalTitleSize.Small;
    return title ? (react_1.default.createElement(modal_1.default.Header, { withTitle: false, className: (0, clsx_1.default)({ 'modal-header_borderless': borderless }) },
        react_1.default.createElement(modal_1.default.TitleSection, null,
            react_1.default.createElement(modal_1.default.Title, { className: (0, clsx_1.default)('modal-title', { 'modal-title_size_sm': isTitleSizeSmall }) },
                status && (react_1.default.createElement(modal_1.default.TitleIndicator, null,
                    react_1.default.createElement(icon_1.default, { symbol: icon }))),
                title)),
        react_1.default.createElement(button_1.default, { type: "button", displayType: isTitleSizeSmall ? button_1.ButtonDisplayType.Fourth : button_1.ButtonDisplayType.Tertiary, size: isTitleSizeSmall ? button_1.ButtonSize.Small : button_1.ButtonSize.Large, symbol: isTitleSizeSmall ? icon_1.IconSymbol.KnowCloseSmall : icon_1.IconSymbol.KnowCloseBig, onClick: onClose }))) : null;
};
ModalHeader.defaultProps = {
    title: '',
    titleSize: types_1.ModalTitleSize.Large,
    status: '',
    icon: icon_1.IconSymbol.InfoCircle,
    borderless: false,
    onClose: () => false,
};
exports.default = ModalHeader;
//# sourceMappingURL=ModalHeader.js.map